import React from 'react'
import './App.css'
import './DownloadPrint.css'
import { Link, Redirect } from 'react-router-dom'
import Axios from 'axios'
import ClipLoader from 'react-spinners/ClipLoader'
import { BiShieldAlt2 } from 'react-icons/bi'
import { API_URL } from './config'

var QRCode = require('qrcode.react')

const PAGE_SIZE = 5 // tickets per A4 page

class Download extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      details: [],
      loadBarProgress: true,
      loadingText: true,
    }
  }

  componentDidMount() {
    const businessname = localStorage.getItem('businessname')
    const businessid = localStorage.getItem('businessid')
    const eventid = localStorage.getItem('eventid')
    const eventname = localStorage.getItem('eventname')
    const reprint = (this.props.location.state || {}).reprint || 'no'
    document.title = 'Ticket print - ' + ' ' + eventname + ' - ' + businessname

    Axios.get(
      `${API_URL}/apps/kscanner/webservices.php?query=TICKETREADYTODOWNLOAD&eventid=${eventid}&reprint=${reprint}`,
      { withCredentials: true },
    )
      .then((response) => {
        const data = Array.isArray(response.data) ? response.data : []
        const ready = data.length > 0 && data.every((t) => t.qr_payload)

        this.setState({ details: data, loadBarProgress: false, loadingText: false }, () => {
          if (!ready) return
          setTimeout(() => window.print(), 600)
          setTimeout(() => {
            Axios.get(
              `${API_URL}/apps/kscanner/webservices.php?query=ALLOCATETICKETS&businessid=${businessid}&eventid=${eventid}`,
              { withCredentials: true },
            ).catch((error) => console.log(error))
          }, 3000)
        })
      })
      .catch((error) => {
        console.log(error)
        this.setState({ loadBarProgress: false, loadingText: false })
      })
  }

  download = () => {
    window.print()
  }

  titleCase = (str) =>
    String(str || '')
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')

  signature = (payload) => String(payload || '').slice(-6)

  typeLabel = (category) => {
    const key = String(category || '')
      .trim()
      .toLowerCase()
    return key === 'vip' ? 'VIP' : key === 'vvip' ? 'VVIP' : 'General'
  }

  renderTicket = (item, number) => {
    const businessname = localStorage.getItem('businessname')
    const age = item.group !== undefined ? item.group : item.age_group
    const isKid = parseInt(age) === 1
    const price = Number(isKid ? item.kids_price : item.price).toFixed(2)
    const venueLines = String(item.venue || '')
      .split(',')
      .map((v) => v.trim())
      .filter(Boolean)

    // watermark sits only in the empty space beside the pill and the time
    const mark = (
      <span
        className="dlt-mark"
        aria-hidden="true"
        style={{ backgroundImage: `url("${API_URL}/logok.png")` }}
      />
    )

    const field = (label, value, cls) => (
      <div className={`dlt-field${cls ? ' ' + cls : ''}`}>
        <span className="dlt-k">{label}</span>
        <span className="dlt-v">{value}</span>
      </div>
    )

    return (
      <article className="dlt" key={item.ticketnumber || number}>
        {/* LEFT: event info */}
        <aside className="dlt-info">
          <div>
            <div className="dlt-row">
              <span className="dlt-pill">Event dates</span>
              {mark}
            </div>
            <div className="dlt-date">
              {item.eventdate} {item.eventmonth}, {item.eventyear}
            </div>
          </div>

          <div className="dlt-row">
            <div>
              <span className="dlt-k">Time</span>
              <span className="dlt-v">
                {item.starttime} - {item.finishtime}
              </span>
            </div>
            {mark}
          </div>

          <div>
            <span className="dlt-k">Venue</span>
            <span className="dlt-v">
              {venueLines.map((line, i) => (
                <span className="dlt-line" key={i}>
                  {line}
                </span>
              ))}
            </span>
          </div>

          <div className="dlt-powered">
            <div className="dlt-brand">
              <span>Powered by</span>

              <b className="dlt-wordmark">
                karamale<i>.</i>
              </b>
            </div>
            <p>
              <b>WhatsApp:</b> +27 66 561 6528
            </p>
          </div>
        </aside>

        {/* CENTER: title + details */}
        <div className="dlt-main">
          <header className="dlt-head">
            <div className="dlt-head-text">
              <h3>{this.titleCase(localStorage.getItem('eventname'))}</h3>
              <p>Hosted by {item.organiserName || businessname}</p>
            </div>
            <span className="dlt-num">{number}</span>
          </header>

          <div className="dlt-grid">
            <section className="dlt-cell">
              <h4>Customer details</h4>
              <div className="dlt-two">
                {field('Issued to', 'Customer')}
                {field('Ticket holder', 'Customer')}
              </div>
            </section>

            <section className="dlt-cell">
              <h4>Cost details</h4>
              <div className="dlt-two">
                {field('Ticket price', `R${price}`)}
                {field('Total', `R${price}`)}
              </div>
            </section>

            <section className="dlt-cell">
              <div className="dlt-two">
                {field('Type', <span className="dlt-type">{this.typeLabel(item.category)}</span>)}
                {field('Admission', '1')}
              </div>
            </section>

            <section className="dlt-cell">
              {field("Organiser's email", item.organiser_email, 'dlt-email')}
            </section>

            <section className="dlt-cell dlt-secure">
              <BiShieldAlt2 size={20} />
              {field('Security Notice', 'Do not share this ticket publicly')}
            </section>

            <section className="dlt-cell">
              {field('Signature', this.signature(item.qr_payload), 'dlt-mono')}
            </section>
          </div>
        </div>

        {/* RIGHT: QR stub */}
        <aside className="dlt-qr">
          <span className="dlt-scan">Scan Here</span>
          <div className="dlt-qr-box">
            {/* <QRCode value={item.qr_payload} logoSize={0} size={100} /> */}
            {item.qr_payload ? (
              <QRCode value={String(item.qr_payload)} size={100} />
            ) : (
              <span className="dlt-k">QR unavailable</span>
            )}
          </div>
          <span className="dlt-code">{item.ticketnumber}</span>
          {/* <span className="dlt-age">{item.age_group == 1 ? 'Child' : 'Adult'}</span> */}
          <span className="dlt-age">{parseInt(age) === 1 ? 'Child' : 'Adult'}</span>
        </aside>
      </article>
    )
  }

  details = () => {
    const { loadingText, details } = this.state

    const groupedTickets = []
    for (let i = 0; i < details.length; i += PAGE_SIZE) {
      groupedTickets.push(details.slice(i, i + PAGE_SIZE))
    }

    if (loadingText) {
      return (
        <div className="dlp-note">
          <ClipLoader size={40} color={'#8d949e'} />
          <br />
          Fetching tickets...
        </div>
      )
    }

    if (details.length <= 0) {
      return (
        <div className="dlp-note">
          It looks like the tickets you are trying to print have already been printed.
          <br />
          If this is not the case, please dial <b>+27 78 236 5403</b> for assistance.
          <br />
          <br />
          <Link to="/dashboard" className="dlp-link">
            Dashboard
          </Link>
        </div>
      )
    }

    return groupedTickets.map((group, pageIndex) => (
      <div className="dlp-sheet" key={pageIndex}>
        {group.map((item, index) => (
          <div className="dlp-slot" key={item.ticketnumber || index}>
            {this.renderTicket(item, pageIndex * PAGE_SIZE + index + 1)}
          </div>
        ))}
      </div>
    ))
  }

  render() {
    if (localStorage.getItem('businessid') === null) {
      return <Redirect to="/login" />
    }

    return (
      <div className="view p-0" style={{ backgroundColor: '#fff' }}>
        <div className="dlp">
          {this.state.details.length > 0 && (
            <div className="dlp-bar">
              <Link to="/dashboard" className="dlp-link">
                Back to dashboard
              </Link>
              <button type="button" className="dlp-btn" onClick={this.download}>
                Print tickets
              </button>
            </div>
          )}
          {this.details()}
        </div>
      </div>
    )
  }
}

export default Download
